import React, { useEffect, useRef, useState } from 'react';
import FormInput from '../../Components/FormInput';
import { showToast } from '../../Components/Toast';
import { EuiButton, EuiDatePicker, EuiFilePicker, EuiFlexGroup, EuiFlexItem, EuiForm, EuiFormRow, EuiImage } from '@elastic/eui';
import axios from '../../axiosService';

const Edit = ({ server, authtoken, EditData, startLoading, stopLoading, setIsEditing }) => {
  const [values, setValues] = useState(EditData);
  const [Photo, setPhoto] = useState(null);
  const [previewPhoto, setPreviewPhoto] = useState(null);
  const [CauseData, setCauseData] = useState([])
  const imgUrl = server + EditData.photo;
  
  const refs = {
    CauseID: useRef(),
    EventName: useRef(),
    EventDate: useRef(),
    Photo: useRef()
  }

  const inputs = [
    {
      id: "causeId",
      name: "causeId",
      type: "select",
      placeholder: "Select a Cause",
      label: "Cause",
      options: [{ value: 0, text: "-- Select Cause --" }, ...CauseData]
    }, {
      id: "eventName",
      name: "eventName",
      type: "text",
      placeholder: "Enter Event Name",
      label: "Event Name"
    }
  ];

  //Preview image
  useEffect(() => {
    if (Photo) {
      const fileExtension = Photo.name.split('.').pop().toLowerCase();

      const imageExtensions = ['jpg', 'jpeg', 'png', 'webp'];

      if (imageExtensions.includes(fileExtension)) {
        const reader = new FileReader();
        reader.onload = () => {
          setPreviewPhoto(reader.result);
        };
        reader.readAsDataURL(Photo);
      } else {
        showToast('Only Image of type ' + imageExtensions.join(",") + ' are Allowed', "error", 2500);
        setPreviewPhoto(imgUrl);
        refs.Photo.current.removeFiles();
      }
    } else {
      setPreviewPhoto(imgUrl);
    }
  }, [Photo])

  const onChange = (e) => {
    setValues({ ...values, [e.target.name]: e.target.value });
  };

  const onDateChange = (date) => {
    setValues({ ...values, eventDate: date });
  };

  function ValidateControls() {
    if (+values.CauseID === 0) {
      refs.CauseID.current.focus();
      showToast('Please Select a Cause', "warning", 1500);
      return false;
    } else if (values.EventName === "") {
      refs.EventName.current.focus();
      showToast('Please Enter Event Name', "warning", 1500);
      return false;
    } else if (values.EventDate === null) {
      refs.EventDate.current.setFocus();
      showToast('Please Select a Date', "warning", 1500);
      return false;
    } else if (!Photo && !previewPhoto) {
      refs.Photo.current.fileInput.focus();
      showToast('Please Select a Image to upload', "warning", 1500);
      return false;
    }
    return true;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (ValidateControls()) {
      try {
        startLoading();

        const formData = new FormData();
        const config = {
          headers: {
            'content-type': 'multipart/form-data',
            'Authorization': "Bearer " + authtoken,
          }
        };

        formData.append('CauseID', values.causeId);
        formData.append('EventID', values.eventId);
        formData.append('EventName', values.eventName);
        formData.append('EventDate', values.eventDate.format("YYYY-MM-DDTkk:mm:ss"));
        if (Photo)
          formData.append('Photo', Photo);

        const response = await axios.put(`${server}api/Event/` + values.eventId, formData, config);

        if (response.status === 200) {
          showToast("Record Updated", "success", 2000);
          setIsEditing(false);
        }
        stopLoading();

      } catch (error) {
        showToast(error.toString(), "error", 15000);
        console.error(error);
        stopLoading();
      }
    }
  };

  const fillCausedata = async () => {
    startLoading();
    try {
      const response = await axios.get(`${server}api/Cause`, {
        headers: {
          'Authorization': "Bearer " + authtoken
        }
      });
      if (response.status === 200) {
        const data = await response.data;
        setCauseData(data.map(item => {
          return {
            value: item.causeID,
            text: item.causeName,
          }
        }));
      }
      stopLoading();
    } catch (error) {
      showToast(error.toString(), "error", 15000);
      stopLoading();
    }
  }

  useEffect(() => {
    fillCausedata();
    // eslint-disable-next-line
  }, [])

  return (
    <EuiForm component='form' onSubmit={handleSubmit} >
      <div style={{ padding: "5px" }}>
        {//renders controls
          inputs.map((input) => (
            <FormInput
              key={input.id}
              {...input}
              value={values[input.name]}
              onChange={onChange}
              inputRef={refs[input.name]}
            />
          ))}
        <EuiFormRow label="Event Date" fullWidth>
          <EuiDatePicker
            showTimeSelect
            id="eventDate"
            name="eventDate"
            selected={values.eventDate}
            onChange={onDateChange}
            placeholder='Please Select a Event Date'
            inputRef={refs.EventDate}
            utcOffset="00:00"
            fullWidth
          />
        </EuiFormRow>
        <EuiFlexGroup>
          <EuiFlexItem grow={false}>
            <EuiFormRow label="Event Banner Image">
              <EuiFilePicker
                onChange={(files) => setPhoto(files[0])}
                ref={refs.Photo}
              />
            </EuiFormRow>
          </EuiFlexItem>
          <EuiFlexItem grow={false} style={{ padding: "20px" }}>
            <EuiFormRow>
              <EuiImage alt='Preview Photo' src={previewPhoto} size="m" allowFullScreen style={{ display: previewPhoto === null ? "none" : "block" }} />
            </EuiFormRow>
          </EuiFlexItem>
        </EuiFlexGroup>
        <br />
        <div style={{ display: 'flex', justifyContent: "start", gap: "20px", alignItems: "center" }}>
          <EuiButton size='m' type='submit' fill>Save</EuiButton>
          <EuiButton size='m' type='button' onClick={() => setIsEditing(false)} color='warning' fill>Cancel</EuiButton>
        </div>
      </div>
    </EuiForm>
  );
};

export default Edit;
